// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.importfileslist.importeditor', {
        url: '/editor/{importFileId}',
        views: {'wideColumnView@product': {
            templateUrl: 'main/product/importeditor/importeditor.tpl.html',
            controller: 'ArticleImportEditorController as vm'
        }},
        resolve: {
            importFile: importFileResolver,
            collections: collectionsResolver,
            itemGroups: itemGroupsResolver,
            articleTypes: articleTypesResolver
        }
    });
}

// @ngInject
function importFileResolver($stateParams, FileDataImportApiService) {
    return FileDataImportApiService.getImportFile($stateParams.importFileId);
}

// @ngInject
function collectionsResolver(FileDataImportApiService) {
    return FileDataImportApiService.getArticleCollections();
}

// @ngInject
function articleTypesResolver(ArticleTypesApiService, $stateParams) {
    return ArticleTypesApiService.getAll($stateParams.searchTerm);
}

// @ngInject
function itemGroupsResolver(FileDataImportApiService) {
    return FileDataImportApiService.getItemGroups();
}

// @ngInject
function ArticleImportEditorController($scope, $state, importFile, collections, articleTypes, itemGroups, FileDataImportApiService, loadSpinnerService,
                                       ToasterService, $translate, AuthService) {
    var vm = this;
    var overviewGrid = {};
    var articleGroupingsGrid = {};
    var intrastatCodeLength = 12;

    var oldArticleGroupingRowValues = {
        alternativeArticleNumber: "",
        articleName: "",
        itemGroupString: "",
        purchaseCost: "",
        salesPrice: "",
        collection: ""
    };

    var errorColor = 'red';
    var warningColor = '#ffff33';
    var noErrorColor = 'green';

    vm.importFile = importFile;
    //default sort
    vm.importFile.articlesOrdersImportRows = _.sortBy(vm.importFile.articlesOrdersImportRows,['alternativeArticleNumber','variant1Name', 'variant2Name']);

    var importFileCollection = new wijmo.collections.CollectionView(vm.importFile.articlesOrdersImportRows);

    vm.validationErrors = [];

    vm.orderInfo = {
        orderNumberExternal: 0,
        plannedDeliveryDate: new Date()
    };

    // --- Read only data sets ---
    vm.collections = collections;
    vm.collectionCodes = [];
    vm.itemGroups = [];
    vm.itemGroupNamesAndCodes = [];
    vm.articleTypes = articleTypes;
    vm.articleTypeNames = [];

    // --- Overview section and general functions. ---
    vm.captureOverviewGrid = captureOverviewGrid;
    vm.saveImportFile = saveImportFile;
    vm.saveAndFinalize = saveAndFinalize;
    vm.wjAutoCompleteSetDefaultValue = wjAutoCompleteSetDefaultValue;
    vm.setWjDefaultItemGroup = setWjDefaultItemGroup;
    vm.setWjDefaultArticleType = setWjDefaultArticleType;

    // --- Overview grid style ---
    vm.getAlternativeArticleNumberStyle = getAlternativeArticleNumberStyle;
    vm.getItemGroupStyle = getItemGroupStyle;
    vm.getArticleTypeStyle = getArticleTypeStyle;
    vm.getColorVariantStyle = getColorVariantStyle;
    vm.getSizeVariantStyle = getSizeVariantStyle;
    vm.getBarcodeStyle = getBarcodeStyle;
    vm.getCollectionStyle = getCollectionStyle;
    vm.getPricesStyle = getPricesStyle;
    vm.getIntrastatStyle = getIntrastatStyle;
    vm.getDepartmentStyle = getDepartmentStyle;

    // --- Articles section variables and vm exposed functions. ---
    vm.distinctAltArticleNumbers = [];
    vm.distinctArticleNames = [];
    vm.altArticleNumberChange = {
        from: "",
        to: ""
    };
    vm.articleNameChange = {
        from: "",
        to: ""
    };
    vm.changeAllAltArticleNumbers = changeAllAltArticleNumbers;
    vm.changeAllArticleNames = changeAllArticleNames;
    vm.rowsGroupedByArticle = [];
    vm.captureArticleGroupingsGrid = captureArticleGroupingsGrid;
    vm.registerOldArticleGroupingInfo = registerOldArticleGroupingInfo;
    vm.copyArticleGroupInformationToAllRelatedRows = copyArticleGroupInformationToAllRelatedRows;

    // --- Colors section variables and vm exposed functions ---
    vm.distinctColors = [];
    vm.colorChange = {
        from: "",
        to: ""
    };
    vm.changeAllColors = changeAllColors;
    vm.rowsGroupedByColor = {};
    vm.collectionChanged = collectionChanged;
    vm.itemGroupChanged = itemGroupChanged;
    vm.articleTypeChanged = articleTypeChanged;

    // --- View switching ---
    vm.switchToOverview = switchToOverview;
    vm.switchToArticles = switchToArticles;
    vm.switchToArticleVariants = switchToArticleVariants;
    vm.switchToColors = switchToColors;
    vm.switchToSizes = switchToSizes;
    vm.switchToSubCategories = switchToSubCategories;
    vm.viewVisibility = {
        overview: true,
        articles: false,
        articleVariants: false,
        colors: false,
        sizes: false,
        subCategories: false
    };
    vm.setIsEditingTrue = setIsEditingTrue;
    vm.setIsEditingFalse = setIsEditingFalse;
    vm.isEditing = false;

    vm.isFileDataOkay = isBarcodeOnWrongArticle;

    vm.showWarningToaster = showWarningToaster;
    vm.canAccess = AuthService.canAccess;
    vm.isAnyBarcodeOnWrongArticle = isAnyBarcodeOnWrongArticle;

    vm.printDebug = printDebug;
    vm.tempvar = "";

    activate();

    function activate() {

        _.forEach(vm.collections, function(collection) {
            vm.collectionCodes.push(collection.collectionCode);
        });

        if (vm.importFile.company) {
            vm.itemGroups = _.filter(itemGroups, function(itemGroup) {
                var containsCompany = false;
                _.forEach(itemGroup.brand.companies, function(company) {
                    if (company.id === vm.importFile.company.id) {
                        containsCompany = true;
                    }
                });
                return containsCompany;
            });
            _.forEach(vm.itemGroups, function(itemGroup) {
                vm.itemGroupNamesAndCodes.push(itemGroup.itemGroupCode + ' ' + itemGroup.itemGroupShortName);
            });
        }

        vm.importFile.shouldGenerateOrder = false;

        $scope.$watch(function() { return vm.importFile.shouldGenerateOrder; }, function() {
            var hasError = false;
            if (vm.importFile.shouldGenerateOrder) {
                hasError = validateOrderInformation();
            }
            if (hasError) {
                vm.importFile.shouldGenerateOrder = false;
                applyScope();
            }
        });

        vm.articleTypeNames = _.map(vm.articleTypes, function (o) { return o.articleTypeName; }); // + ' (' + o.articleSystemType + ')'; });
    }

    function captureOverviewGrid(sender) {
        overviewGrid = sender;
        overviewGrid.itemsSource = importFileCollection;
    }

    // =================================================
    //  Editor view switching
    // =================================================
    function switchToOverview() {
        setVisibilityToNone();
        vm.viewVisibility.overview = true;
        refreshOverviewGrid();
        applyScope();
    }

    function switchToArticles() {
        constructDistinctArticleData();
        groupRowsByArticle();

        setVisibilityToNone();
        vm.viewVisibility.articles = true;
        applyScope();
    }

    function switchToArticleVariants() {
        // Prep work here.
        setVisibilityToNone();
        vm.viewVisibility.articleVariants = true;
        applyScope();
    }

    function switchToColors() {
        constructDistinctColorData();
        groupRowsByColor();

        setVisibilityToNone();
        vm.viewVisibility.colors = true;
        applyScope();
    }

    function switchToSizes() {
        // Prep work here.
        setVisibilityToNone();
        vm.viewVisibility.sizes = true;
        applyScope();
    }

    function switchToSubCategories() {
        // Prep work here.
        setVisibilityToNone();
        vm.viewVisibility.subCategories = true;
        applyScope();
    }

    // Set all visibility determining variables to false.
    function setVisibilityToNone() {
        vm.viewVisibility.overview = false;
        vm.viewVisibility.articles = false;
        vm.viewVisibility.articleVariants = false;
        vm.viewVisibility.colors = false;
        vm.viewVisibility.sizes = false;
        vm.viewVisibility.subCategories = false;
    }

    // =================================================
    //  General
    // =================================================
    // Sends that updated data to the backend and retreives the result (meaning an updated data structure potentially
    // containing references to linked data structures)
    function saveImportFile() {

        _.forEach(vm.importFile.articlesOrdersImportRows, function(importRow) {
            //importRow.plannedDeliveryDate = vm.orderInfo.plannedDeliveryDate;
            importRow.orderNumberExternal = vm.orderInfo.orderNumberExternal;
        });

        vm.validationErrors = [];
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiService.updateArticlesOrdersImportFile(vm.importFile).then(function(response) {
            console.log(response);

            vm.importFile = response;
            overviewGrid.itemsSource = new wijmo.collections.CollectionView(vm.importFile.articlesOrdersImportRows);

            refreshOverviewGrid();
            constructDistinctArticleData();
            groupRowsByArticle();
            applyScope();
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    // Finalizes the import file, generating new data structures in the backend. This decision is final.
    function saveAndFinalize() {

        _.forEach(vm.importFile.articlesOrdersImportRows, function(importRow) {
            //importRow.plannedDeliveryDate = vm.orderInfo.plannedDeliveryDate;
            importRow.orderNumberExternal = vm.orderInfo.orderNumberExternal;
        });

        vm.validationErrors = [];
        loadSpinnerService.start('mainSpinner');
        FileDataImportApiService.updateAndFinalizeArticlesOrdersImportFile(vm.importFile).then(function(response) {
            console.log(response);

            $state.go('product.importfileslist');
        }, function(error) {
            console.log(error);

            vm.validationErrors.push(error.message);

        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    // Needed to determine the value that value that the autoComplete should show on load.
    function wjAutoCompleteSetDefaultValue(sender, rowItem, propertyName) {
        sender.selectedValue = rowItem[propertyName];
    }

    // Needed to determine the value that the autoComplete should show when switching to the view
    function setWjDefaultItemGroup(sender, rowItem) {
        var startingItem = _.find(vm.itemGroupNamesAndCodes, function(item) {
            return item.indexOf(rowItem.itemGroupString) > -1;
        });
        sender.selectedValue = startingItem;
    }

    function setWjDefaultArticleType(sender, rowItem) {
        var startingItem = _.find(vm.articleTypeNames, function(item) {
            return item.indexOf(rowItem.articleTypeString) > -1;
        });
        sender.selectedValue = startingItem;
    }

    // ================================================================
    //  Overview grid style (Color code cells depending on situation)
    // ================================================================
    // Alternative Article Number
    function getAlternativeArticleNumberStyle(cellItem) {
        var style = {};
        if (cellItem.alternativeArticleNumber === undefined || cellItem.alternativeArticleNumber === "" || isBarcodeOnWrongArticle(cellItem)) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else if (cellItem.article === undefined || (cellItem.article !== undefined && cellItem.alternativeArticleNumber.toLowerCase() !== cellItem.article.alternativeArticleNumber.toLowerCase())) {
            style['background-color'] = warningColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Intrastat
    function getIntrastatStyle(cellItem) {
        var style = {};

        style['color'] = noErrorColor;

        if (cellItem.intrastatCode && cellItem.intrastatCode.length !== intrastatCodeLength) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        }

        return style;
    }

    // Item Group
    function getItemGroupStyle(cellItem) {
        var style = {};

        var containsCompany = false;
        if (cellItem.itemGroup && cellItem.itemGroup.brand) {
            _.forEach(cellItem.itemGroup.brand.companies, function(company) {
                if (company.id === vm.importFile.company.id) {
                    containsCompany = true;
                }
            });
        }

        if (cellItem.itemGroup === undefined || containsCompany) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Intrastat
    function getArticleTypeStyle(cellItem) {
        var style = {};

        style['color'] = noErrorColor;

        return style;
    }

    // Color variant
    function getColorVariantStyle(cellItem) {
        var style = {};
        if (cellItem.variant1Name === undefined || cellItem.variant1Name === "") {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else if (cellItem.variantDetail1 === undefined && cellItem.variant1Name !== "") {
            style['background-color'] = warningColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Size variant
    function getSizeVariantStyle(cellItem) {
        var style = {};
        if (cellItem.variantDetail2 === undefined /*cellItem.variant2Name === undefined || cellItem.variant2Name === ""*/) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else if (cellItem.variantDetail2 === undefined && cellItem.variant2Name !== "") {
            style['background-color'] = warningColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Barcode
    function getBarcodeStyle(cellItem) {
        var style = {};
        var itemsWithSameBarcode = _.filter(vm.importFile.articlesOrdersImportRows, function(row) {
            return row.barcode === cellItem.barcode;
        });

        var existsDifferentArticleWithSameBarcode = false;
        for (var i = 0; i < itemsWithSameBarcode.length; i++) {
            if (itemsWithSameBarcode[i].alternativeArticleNumber !== cellItem.alternativeArticleNumber ||
                itemsWithSameBarcode[i].variant1Name !== cellItem.variant1Name ||
                itemsWithSameBarcode[i].variant2Name !== cellItem.variant2Name) {
                existsDifferentArticleWithSameBarcode = true;
                break;
            }
        }

        if (cellItem.barcode === undefined || cellItem.barcode === "" || existsDifferentArticleWithSameBarcode) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else if (cellItem.articleVariant === undefined) {
            style['background-color'] = warningColor;
        } else {
            style['color'] = noErrorColor;
        }

        return style;
    }

    // Collection
    function getCollectionStyle(cellItem) {
        var style = {};
        if (cellItem.articleCollection === undefined) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Prices
    function getPricesStyle(cellItem) {
        var style = {};
        if (cellItem.purchaseCost * 2 > cellItem.salesPrice || cellItem.purchaseCost * 6 < cellItem.salesPrice) {
            style['background-color'] = warningColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    // Department
    function getDepartmentStyle(cellItem) {
        var style = {};
        if (cellItem.departmentCode !== "" && (cellItem.department === undefined || cellItem.department.id === undefined)) {
            style['background-color'] = errorColor;
            style['color'] = 'white';
        } else {
            style['color'] = noErrorColor;
        }

        return style;
    }


    // =================================================
    //  Articles section
    // =================================================
    function constructDistinctArticleData() {
        vm.distinctAltArticleNumbers = [];
        vm.distinctArticleNames = [];

        var uniqueObjectsWithAltArticleNumbers = _.uniq(vm.importFile.articlesOrdersImportRows, false, function(item) {
            return item.alternativeArticleNumber;
        });

        var uniqueObjectsWithArticleNames = _.uniq(vm.importFile.articlesOrdersImportRows, false, function(item) {
            return item.articleName;
        });

        _.forEach(uniqueObjectsWithAltArticleNumbers, function(item) {
            vm.distinctAltArticleNumbers.push(item.alternativeArticleNumber);
        });

        _.forEach(uniqueObjectsWithArticleNames, function(item) {
            vm.distinctArticleNames.push(item.articleName);
        });
    }

    function groupRowsByArticle() {
        vm.rowsGroupedByArticle = [];

        var fullArticleGrouping = _.groupBy(vm.importFile.articlesOrdersImportRows, function(importRow) {
            return getArticleGroupingKey(importRow);
        });

        var groupingKeys = Object.keys(fullArticleGrouping);

        _.forEach(groupingKeys, function(key) {
            vm.rowsGroupedByArticle.push(fullArticleGrouping[key][0]);
        });

        articleGroupingsGrid.itemsSource = new wijmo.collections.CollectionView(vm.rowsGroupedByArticle);
    }

    function changeAllAltArticleNumbers() {
        var rowsToChange = _.filter(vm.importFile.articlesOrdersImportRows, {alternativeArticleNumber: vm.altArticleNumberChange.from});

        for (var i = 0; i < rowsToChange.length; i++) {
            rowsToChange[i].alternativeArticleNumber = vm.altArticleNumberChange.to;
        }
        vm.altArticleNumberChange.from = vm.altArticleNumberChange.to;

        constructDistinctArticleData();
        groupRowsByArticle();
    }

    function changeAllArticleNames() {
        var rowsToChange = _.filter(vm.importFile.articlesOrdersImportRows, { articleName: vm.articleNameChange.from });

        for (var i = 0; i < rowsToChange.length; i++) {
            rowsToChange[i].articleName = vm.articleNameChange.to;
        }
        vm.articleNameChange.from = vm.articleNameChange.to;

        constructDistinctArticleData();
        groupRowsByArticle();
    }

    function captureArticleGroupingsGrid(sender) {
        articleGroupingsGrid = sender;
        articleGroupingsGrid.itemsSource = new wijmo.collections.CollectionView(vm.rowsGroupedByArticle);
    }

    function registerOldArticleGroupingInfo() {
        var row = articleGroupingsGrid.itemsSource.currentEditItem;

        oldArticleGroupingRowValues.alternativeArticleNumber = row.alternativeArticleNumber;
        oldArticleGroupingRowValues.articleName = row.articleName;
        oldArticleGroupingRowValues.articleTypeString = row.articleTypeString;
        oldArticleGroupingRowValues.itemGroupString = row.itemGroupString;
        oldArticleGroupingRowValues.purchaseCost = row.purchaseCost;
        oldArticleGroupingRowValues.salesPrice = row.salesPrice;
        oldArticleGroupingRowValues.collection = row.collection;
    }

    function copyArticleGroupInformationToAllRelatedRows(rowItem) {

        var row;
        if (typeof rowItem === 'undefined') {
            row = articleGroupingsGrid.itemsSource.currentEditItem;
        } else {
            row = rowItem;
        }

        var key = getArticleGroupingKey(oldArticleGroupingRowValues);

        var fullArticleGrouping = _.groupBy(vm.importFile.articlesOrdersImportRows, function(importRow) {
            return getArticleGroupingKey(importRow);
        });

        var rowsToUpdate = fullArticleGrouping[key];

        _.forEach(rowsToUpdate, function(rowToUpdate) {
            rowToUpdate.alternativeArticleNumber = row.alternativeArticleNumber;
            rowToUpdate.articleName = row.articleName;
            rowToUpdate.articleTypeString = row.articleTypeString;
            rowToUpdate.itemGroupString = row.itemGroupString;
            rowToUpdate.purchaseCost = row.purchaseCost;
            rowToUpdate.salesPrice = row.salesPrice;
            rowToUpdate.collection = row.collection;
        });
    }

    function getArticleGroupingKey(importRow) {
        return importRow.alternativeArticleNumber + " " +
            importRow.articleName + " " +
            importRow.itemGroupString + " " +
            importRow.purchaseCost + " " +
            importRow.salesPrice + " " +
            importRow.collection;
    }

    // =================================================
    //  Colors section
    // =================================================
    function constructDistinctColorData() {
        vm.distinctColors = [];

        var uniqueObjectsByColor = _.uniq(vm.importFile.articlesOrdersImportRows, false, function(item) {
            return item.variant1Name;
        });

        _.forEach(uniqueObjectsByColor, function(item) {
            vm.distinctColors.push(item.variant1Name);
        });
    }

    function groupRowsByColor() {
        vm.rowsGroupedByColor = {};

        vm.rowsGroupedByColor = _.groupBy(vm.importFile.articlesOrdersImportRows, function(importRow) {
            return importRow.variant1Name;
        });
    }

    function changeAllColors() {
        var rowsToChange = _.filter(vm.importFile.articlesOrdersImportRows, { variant1Name: vm.colorChange.from });

        for (var i = 0; i < rowsToChange.length; i++) {
            rowsToChange[i].variant1Name = vm.colorChange.to;
        }
        vm.colorChange.from = vm.colorChange.to;

        constructDistinctColorData();
    }

    function collectionChanged(s, rowItem) {
        if (!s.selectedItem || s.isDroppedDown) {
            return;
        }

        oldArticleGroupingRowValues.alternativeArticleNumber = rowItem.alternativeArticleNumber;
        oldArticleGroupingRowValues.articleName = rowItem.articleName;
        oldArticleGroupingRowValues.articleTypeString = rowItem.articleTypeString;
        oldArticleGroupingRowValues.itemGroupString = rowItem.itemGroupString;
        oldArticleGroupingRowValues.purchaseCost = rowItem.purchaseCost;
        oldArticleGroupingRowValues.salesPrice = rowItem.salesPrice;
        oldArticleGroupingRowValues.collection = rowItem.collection;

        var selectedItem = s.selectedItem;

        rowItem.collection = selectedItem;

        copyArticleGroupInformationToAllRelatedRows(rowItem);
    }

    function itemGroupChanged(s, rowItem) {
        if (!s.selectedItem || s.isDroppedDown) {
            return;
        }

        oldArticleGroupingRowValues.alternativeArticleNumber = rowItem.alternativeArticleNumber;
        oldArticleGroupingRowValues.articleName = rowItem.articleName;
        oldArticleGroupingRowValues.articleTypeString = rowItem.articleTypeString;
        oldArticleGroupingRowValues.itemGroupString = rowItem.itemGroupString;
        oldArticleGroupingRowValues.purchaseCost = rowItem.purchaseCost;
        oldArticleGroupingRowValues.salesPrice = rowItem.salesPrice;
        oldArticleGroupingRowValues.collection = rowItem.collection;

        var selectedItem = s.selectedItem;

        rowItem.itemGroupString = selectedItem.split(' ')[0];

        copyArticleGroupInformationToAllRelatedRows(rowItem);
    }

    function articleTypeChanged(s, rowItem) {
        if (!s.selectedItem || s.isDroppedDown) {
            return;
        }

        oldArticleGroupingRowValues.articleTypeString = rowItem.articleTypeString;

        var selectedItem = s.selectedItem;

        rowItem.articleTypeString = selectedItem.split(' ')[0];

        copyArticleGroupInformationToAllRelatedRows(rowItem);
    }

    function isAnyBarcodeOnWrongArticle() {
        var returnValue = false;
        _.forEach(vm.importFile.articlesOrdersImportRows, function(row) {
            if (row === undefined || row === null) {
                return;
            }
            var result = isBarcodeOnWrongArticle(row);
            if (result === true) {
                returnValue = true;
                return false; // Break _.forEach()
            }
        });
        return returnValue;
    }

    function isBarcodeOnWrongArticle(row) {
        // if ((row.article === undefined || (row.article !== undefined && row.alternativeArticleNumber !== row.article.alternativeArticleNumber)) &&
        //     row.articleVariant !== undefined && (row.article !== undefined && row.articleVariant.article.id === row.article.id)) {
        //     return true;
        // }

        if (row.articleVariant === undefined) {
            return false;
        }

        var articleNumberIsntTheSame = (row.article !== undefined && row.alternativeArticleNumber !== row.article.alternativeArticleNumber);
        var articleDidntExistButArticleVariantDid = (row.articleVariant.article !== undefined && row.article === undefined);
        var articleIdIsntTheSame = (row.article !== undefined && row.articleVariant.article !== undefined && row.articleVariant.article.id !== row.article.id);

        if (articleNumberIsntTheSame ||
            articleDidntExistButArticleVariantDid ||
            articleIdIsntTheSame) {
            return true;
        }

        return false;
    }

    function setIsEditingTrue() {
        vm.isEditing = true;
        applyScope();
    }

    function setIsEditingFalse() {
        vm.isEditing = false;
        applyScope();
    }

    function refreshOverviewGrid() {
        overviewGrid.invalidate();
    }

    function applyScope() {
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function validateOrderInformation() {
        var hasError = false;

        if (vm.importFile.company === undefined) {
            showWarningToaster($translate.instant('import.companyIsMissing'));
            hasError = true;
        }
        if (vm.importFile.location === undefined) {
            showWarningToaster($translate.instant('import.locationIsMissing'));
            hasError = true;
        }

        var someRowsAreWithoutQuantity = _.some(vm.importFile.articlesOrdersImportRows, function(importRow) {
            return importRow.quantity === undefined || importRow.quantity === "";
        });

        if (someRowsAreWithoutQuantity) {
            showWarningToaster($translate.instant('import.quantitiesAreMissing'));
            hasError = true;
        }

        var someQuantitiesAreMalformed = _.some(vm.importFile.articlesOrdersImportRows, function(importRow) {
            return importRow.quantity.indexOf('.') !== -1;
        });

        if (someQuantitiesAreMalformed) {
            showWarningToaster($translate.instant('import.quantitiesAreMalformed'));
            hasError = true;
        }

        return hasError;
    }

    function showWarningToaster(message) {
        var title = $translate.instant('common.warning');
        ToasterService.showWarning(message, title);
    }

    function printDebug() {
        console.log("vm.importFile");
        console.log(vm.importFile);

        console.log("vm.rowsGroupedByArticle");
        console.log(vm.rowsGroupedByArticle);

        console.log("vm.rowsGroupedByColor");
        console.log(vm.rowsGroupedByColor);

        console.log("Refreshing grid...");
        refreshOverviewGrid();

        console.log("vm.collections");
        console.log(vm.collections);

        console.log("vm.itemGroups");
        console.log(vm.itemGroups);

        applyScope();
    }
}

angular
    .module('importfileslist.importeditor', [])
    .config(stateConfig)
    .controller('ArticleImportEditorController', ArticleImportEditorController);
